import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('UI crashed:', error, errorInfo);
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/0f50a1bb-06d4-4480-a68c-70f1e59a674f', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        location: 'ErrorBoundary.jsx:componentDidCatch',
        message: 'render_crash',
        data: {
          errMsg: error?.message,
          errName: error?.name,
          componentStack: errorInfo?.componentStack?.slice?.(0, 500),
        },
        timestamp: Date.now(),
        hypothesisId: 'H6_boundary',
      }),
    }).catch(() => {})
    // #endregion
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="bg-white rounded-lg shadow-sm border border-red-200 p-6 h-full">
          <div className="text-center">
            <div className="text-4xl mb-2">⚠️</div>
            <h3 className="text-lg font-semibold text-gray-900">Something went wrong</h3>
            <p className="text-sm text-gray-600 mt-2">
              The results view hit an unexpected error. Please try switching strategies again or re-running the analysis.
            </p>
            {this.state.error?.message && (
              <pre className="mt-4 text-left text-xs bg-gray-50 border border-gray-200 rounded p-3 overflow-auto">
                {this.state.error.message}
              </pre>
            )}
            {typeof this.props.onReset === 'function' && (
              <button
                className="mt-4 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
                onClick={() => {
                  this.setState({ hasError: false, error: null });
                  this.props.onReset();
                }}
              >
                Reset view
              </button>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

